export default __webpack_public_path__ + "static/media/master1.c93fb7d5.png";